export const MUTATION_GROUP = 'multipleVersionPickerFields' as const;
